import Backpack from '@/src/assets/svgs/Backpack'
import { Luggage } from '@mui/icons-material'
import { Box, Tooltip, Typography } from '@mui/material'

const SegmentBaggage = ({
    cab,
    cib,
    freeText,
    viewBaggageCta,
    cabinBaggageCta,
    checkinBaggageCta
}: {
    cab: string
    cib: string
    freeText: string
    viewBaggageCta: string
    cabinBaggageCta: string
    checkinBaggageCta: string
}) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
                mt: 2
            }}
        >
            {freeText ? (
                <Tooltip title={freeText}>
                    <Typography component="span" sx={{ fontSize: 13, fontWeight: 500, color: 'link.main' }}>
                        {viewBaggageCta}
                    </Typography>
                </Tooltip>
            ) : (
                <>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Backpack sx={{ fontSize: 14, color: 'textColors.secondary' }} />
                        <Box>
                            <Typography sx={{ fontSize: 11, color: 'textColors.secondary' }}>
                                {cabinBaggageCta}:{' '}
                                <Typography
                                    component="span"
                                    sx={{ fontSize: 11, fontWeight: 600, color: 'textColors.primary' }}
                                >
                                    {cab}
                                </Typography>
                            </Typography>
                        </Box>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Luggage sx={{ fontSize: 14, color: 'textColors.secondary' }} />
                        <Box>
                            <Typography sx={{ fontSize: 11, color: 'textColors.secondary' }}>
                                {checkinBaggageCta}:{' '}
                                <Typography
                                    component="span"
                                    sx={{ fontSize: 11, fontWeight: 600, color: 'textColors.primary' }}
                                >
                                    {cib}
                                </Typography>
                            </Typography>
                        </Box>
                    </Box>
                </>
            )}
        </Box>
    )
}

export default SegmentBaggage
